import {FC} from "react"
import Image from "next/image"
import onboardingImg3Src from "public/images/onboarding-3.png"
import {Block} from "./Block"
import {CoursePageProps} from "./CoursePageProps"

export const CheckUpDescription: FC<Pick<CoursePageProps, "course">> = () => {
  return (
    <>
      <Block>
        <p>
          Welcome to YUNG. You’re about to embark on a journey to rapidly improve your
          personal mental wellness. Our AI-assisted therapy will guide you through
          four stages of therapeutic transformation. This is <b>Stage 1, Check-up.</b>
        </p>

        <h1 className="mt-16">What Should I Expect?</h1>
        <p>Our program relies on three pillars: <b>diagnostics, personalization</b>,
          and <b>psychotherapy</b>.
        </p>
        <p>Therefore, each YUNG session consists of:</p>
        <ul className="list-rhombus">
          <li>Core Practice - a guided therapeutic audio assembled by YUNG’s AI
            specifically for you
          </li>
          <li>Articles + exercises that expand on your Core Practice for improved
            results
          </li>
          <li>A series of quick diagnostic questions to help us get to know you</li>
        </ul>
      </Block>

      <Block>
        <p>
          Each session takes 20 to 30 minutes.{" "}
          <b>
            Once you finish seven sessions, you’re done with Check-up
          </b>.
        </p>
        <p>
          At any time, you can chat with a YUNG Psychologist about your guided session to discuss
          insights, ask questions, or just have a conversation and get support.
        </p>
        <p>Additionally, your diagnostic report highlights your challenge areas and shares
          psychological resources, recommended actions, and personalized activities
          to improve your internal state and help you overcome them.
        </p>
      </Block>

      <div className="flex align-middle justify-center p-8 mt-8">
        <Image src={onboardingImg3Src} height={234} width={320} alt="" />
      </div>

      <Block>
        <h1 className="mt-16">Program Outcomes</h1>
        <p>This stage is like a medical check-up for your mental health. Each question
          you answer increases your dashboard’s insights to help identify:
        </p>

        <ul className="list-rhombus">
          <li><b>Negative symptoms</b> such as depression and anxiety
          </li>
          <li><b>Emotional functioning</b> - Which are suppressed and which cause problems
            with control
          </li>
          <li><b>Behavioral issues</b> that can deteriorate your quality of life</li>
          <li><b>Useful skills and traits</b> to develop for improved wellness</li>
          <li><b>Possible causes</b> of emotional and behavioral challenges</li>
        </ul>

        <p>
          Once you finish check-up, you will better understand yourself and your psyche,
          as well as what affects it negatively or positively. This information
          is only for you to help you improve and grow.
        </p>
      </Block>

      <Block>
        <h1 className="mt-16">What’s Next?</h1>
        <p>
          YUNG emulates the psychotherapeutic process: first, we learn what’s going on inside
          of you, then we build resources for you, work with deep problems, and develop new
          and useful skills and solutions to help you. By the time you finish Check-up, our
          AI is trained to support your specific needs and will recommend highly-effective
          programs based on your results.
        </p>
      </Block>
    </>
  )
}
